<template>
  <div>
    <div v-if="isHaveMerNo">
      <el-row class="parent">
        <el-col :span="24" class="toolbar formbg" style="padding-bottom: 0px">
          <el-form ref="searchForm" inline class="form-search inputStyle" :model="searchForm" label-width="110px">
            <el-form-item label="商户编号：" prop="merNo" v-if="platformMerchantType == '1'">
              <el-input v-model="searchForm.merNo" placeholder="输入商户编号" clearable />
            </el-form-item>
            <el-form-item label="商户名称：" prop="merName" v-if="platformMerchantType == '1'">
              <el-input v-model="searchForm.merName" placeholder="输入商户名称" clearable />
            </el-form-item>
            <el-form-item label="申报编号：" prop="declareNo">
              <el-input v-model="searchForm.declareNo" placeholder="请输入申报编号" clearable />
            </el-form-item>
            <el-form-item label="申报金额：" prop="declareAmount">
              <el-input v-model="searchForm.minDeclareAmount" style="width: 125px" clearable @blur="check_amount($event, 'minDeclareAmount')">
                <span slot="suffix">元</span>
              </el-input>
              ~
              <el-input v-model="searchForm.maxDeclareAmount" style="width: 125px" clearable @blur="check_amount($event, 'maxDeclareAmount')">
                <span slot="suffix">元</span>
              </el-input>
            </el-form-item>
            <el-form-item label="申报状态：" prop="declareStatus">
              <el-select v-model="searchForm.declareStatus" placeholder="申报状态" clearable>
                <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="申报日期：" prop="declareTime">
              <el-date-picker
                v-model="searchForm.declareTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                type="daterange"
                range-separator="~"
                style="width: 270px"
              />
            </el-form-item>
            <el-form-item label="交易状态：" prop="paymentStatus">
              <el-select v-model="searchForm.paymentStatus" placeholder="交易状态" clearable>
                <el-option label="全部" value="" />
                <el-option v-for="item in paymentStatus" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="操作：">
              <el-button type="primary" :loading="listLoading" @click="queryData()">查询</el-button>
              <el-button type="primary" @click="clearUp()" plain>重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-table
          v-loading="listLoading"
          stripe
          class="common-list"
          :data="tableData"
          style="width: 100%; margin-bottom: 20px"
          border
          row-key="id"
          element-loading-text="数据加载中，请稍等"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column fixed="left" label="序号" type="index" width="50" align="center" />
          <el-table-column fixed="left" prop="declareNo" label="申报编号" width="150" align="center" />
          <el-table-column fixed="left" prop="merNo" label="商户编号" width="150" align="center" />
          <el-table-column prop="merName" label="商户名称" width="150" align="center" />
          <el-table-column prop="declareType" label="申报类型" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in declareType" :key="index">
                <div v-if="item.value == scope.row.declareType">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="申报币种" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in currency" :key="index">
                <div v-if="item.value == scope.row.currency">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="declareAmount" label="申报金额(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.declareAmount / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="paymentAmount" label="付款金额(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.paymentAmount / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="declareNum" label="申报笔数" width="100" align="center" />
          <el-table-column prop="tradeStatus" label="订单申报文件状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in restoreStatus" :key="index">
                <div v-if="item.value == scope.row.tradeStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="restoreStatus" label="还原申报文件状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in restoreStatus" :key="index">
                <div v-if="item.value == scope.row.restoreStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="declareSource" label="申报来源" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in declareSourceList" :key="index">
                <div v-if="item.value == scope.row.declareSource">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="declareStatus" label="申报状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in declareStatus" :key="index">
                <div v-if="item.value == scope.row.declareStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="declareTime" :formatter="formatDate" label="申报日期" width="180" align="center" />
          <el-table-column prop="paymentFee" label="跨境付款手续费(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.paymentFee / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="telegramFee" label="跨境付款电报费(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.telegramFee / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="intermediateFee" label="跨境付款中间行手续费(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.intermediateFee / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeFee" label="换汇手续费(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.exchangeFee / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="totalFee" label="跨境手续费合计(元)" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.totalFee / 100) | toThousandFilter }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="reviewMsg" label="回退原因" width="150" align="center" />
          <!-- <el-table-column prop="auditStatus" label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item,index) in auditStatus" :key="index">
                <div v-if="item.value == scope.row.auditStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="paymentStatus" label="交易状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in paymentStatus" :key="index">
                <div v-if="item.value == scope.row.paymentStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="reviewStatus" label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in reviewStatus" :key="index">
                <div v-if="item.value == scope.row.reviewStatus">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeMark" label="是否换汇" width="100" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in exchangeMark" :key="index">
                <div v-if="item.value == scope.row.exchangeMark">{{ item.label }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payeeAccNameMask" label="收款人名称" width="150" align="center" />
          <el-table-column prop="payeeAccNoMask" label="收款人账号" width="150" align="center" />
          <el-table-column prop="createTime" :formatter="formatDate" label="申请日期" width="180" align="center" />
          <el-table-column prop="declareNo" label="已传附件信息" width="100" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="downloadDeclareFile(scope.row)">下载</el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button size="mini" style="margin-top: 1px" type="text" @click="handleDetail(scope.row.declareNo)">订单详情</el-button>
              <el-button
                v-if="
                  scope.row.restoreStatus === '00' &&
                  (scope.row.reviewStatus == '02' || scope.row.reviewStatus == '04') &&
                  scope.row.declareSource === '1' &&
                  scope.row.merNo === logInMerNo
                "
                size="mini"
                style="margin-top: 1px"
                type="text"
                @click="openEdit(scope.$index, scope.row)"
                >重新申报</el-button
              >
              <el-button
                v-if="scope.row.declareSource === '1' && scope.row.merNo === logInMerNo"
                size="mini"
                style="margin-top: 1px"
                type="text"
                @click="openAttached(scope.$index, scope.row)"
                >附件资料补充</el-button
              >
              <!-- <el-button size="mini" @click="openAttached2(scope.row)">附件资料补充2</el-button>declareSource
              <el-button size="mini" @click="openAttached3(scope.row)">附件资料补充3</el-button> reviewStatus -->
              <!-- <el-button size="mini" @click="openAttached4(scope.row)">附件资料补充4</el-button> -->
              <el-button size="mini" type="text" @click="openDeclareDialog(scope.row)">还原文件下载</el-button>
              <el-button size="mini" type="text" @click="openOrderDialog(scope.row)">订单重传详情</el-button>
              <el-button
                size="mini"
                type="text"
                v-if="(scope.row.restoreStatus == '03' || scope.row.reviewStatus === '02') && scope.row.merNo === logInMerNo"
                :loading="singleIndex === scope.$index"
                @click="showDownloadDialog(scope.row.declareNo)"
                >失败原因下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--分页工具条-->
        <pagination v-show="total > 0" :total="total" :page.sync="page" :current-page="page" :limit.sync="size" @pagination="queryDeclareOrder(page, size)" />
      </el-row>
      <el-dialog title="详情查看" :visible.sync="detailFormVisible" width="80%" :close-on-click-modal="false">
        <div style="margin-top: 10px">
          <el-table
            stripe
            class="common-list"
            :data="detailForm"
            :header-cell-style="{ background: '#EDF7FE' }"
            element-loading-text="使劲加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            border
            row-key="id"
          >
            <el-table-column label="序号" type="index" width="50" align="center" />
            <el-table-column prop="merOrderNo" label="商户订单号" align="center" />
            <el-table-column prop="tradeDate" label="交易日期" align="center" />
            <el-table-column prop="goodsName" label="商品名称" align="center" />
            <el-table-column prop="goodsNum" label="商品数量" align="center" />
            <el-table-column prop="unitPrice" label="金额(元)" align="center" />
            <el-table-column prop="paymentAmount" label="订单总金额">
              <template slot-scope="scope" prop="paymentAmount">
                <span>{{ scope.row.paymentAmount / 100 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payerType" label="付款方类型" align="center" />
            <el-table-column prop="payerName" label="付款人名称" align="center" />
            <el-table-column prop="payerCode" label="付款方机构代码" align="center" />
            <el-table-column prop="paymentType" label="付款类型" align="center" />
            <el-table-column prop="tradeCode" label="交易编码" align="center" />
            <el-table-column prop="tradeRmk" label="交易附言" align="center" />
            <el-table-column prop="isBondedGoods" label="是否保税货物项下付款" align="center" />
            <el-table-column prop="contractNo" label="合同号" align="center" />
            <el-table-column prop="invoiceNo" label="发票号" align="center" />
            <el-table-column prop="declarationNo" label="报关单号(选填)" align="center" />
            <el-table-column prop="logistics" label="物流公司名称" align="center" />
            <el-table-column prop="logisticsNo" label="物流单号" align="center" />
          </el-table>
          <!-- 列表渲染结束 -->
          <!--分页工具条-->
          <pagination
            v-show="detailsTotal > 0"
            :total="detailsTotal"
            :page.sync="detailsPage"
            :limit.sync="detailsSize"
            :current-page="detailsPage"
            @pagination="handleDetailByPage()"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="detailFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 路由编辑组件 -->
    <edit ref="edit" />
    <attached ref="attached" />
    <!-- <attached2 ref="attached2" />
    <attached3 ref="attached3" /> -->
    <!-- <attached-4 ref="attached4"/> -->

    <declare-file-list ref="declareFileList" />

    <declare-origin-file-list ref="declareOriginFileList"></declare-origin-file-list>

    <!-- 订单重传对话框 -->
    <order-reload ref="orderReload" @success="orderReloadSuccess" :visible="orderVisible" />

    <!-- 导出对话框 -->
    <el-dialog title="导出提示" :visible.sync="downloadVisible" width="40%" :close-on-click-modal="false" @before-close="closeDownloadDialog">
      <el-form label-width="120px">
        <el-form-item label="文件名称">
          <el-input v-model.trim="downloadFilename" placeholder="请输入下载文件名称" maxlength="120" @blur="check_filename($event)" clearable></el-input>
        </el-form-item>
        <el-form-item label="提示">
          <span>当前文件下载完成后，请前往跨境业务管理->文件下载页面查看。</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDownloadDialog">取消</el-button>
        <el-button type="primary" @click="downloadFail" :loading="downloadLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateDeclarationInfo } from '@/api/crossborder/declare/restore/restore'
import {
  queryMerDeclareOrder,
  downloadDeclareFile,
  queryDeclareOrderDetails,
  declarationFileDownload,
  declarationFileDownloadAsync,
} from '@/api/crossborder/declare/restore/declare'
import Pagination from '@/components/Pagination'
import moment from 'moment'
import orderReload from './orderReload'
import declareFileList from './declareFileList'
import declareOriginFileList from './declareOriginFileList'
import DeclareEdit from '@/views/crossborder/paymentInquiry/edit'
import DeclareAttached from '@/views/crossborder/paymentInquiry/attached'
import Common from '@/utils/common' // 工具类
import CommonApi from '@/api/common/common'
import { mapGetters } from 'vuex'

export default {
  name: 'Restore',
  components: {
    Pagination,
    edit: DeclareEdit,
    attached: DeclareAttached,
    orderReload,
    declareFileList,
    declareOriginFileList,
    // attached2,
    // attached3
    // attached4
  },

  data: function () {
    return {
      isHaveMerNo: true,
      // 查询数据
      searchForm: {
        merNo: null,
        merName: null,
        declareTime: null,
        declareStatus: null,
        restoreStatus: null,
        tradeStatus: null,
        restoreNo: null,
        tradeNo: null,
        auditStatus: null,
        orderStatus: null,
        paymentStatus: null,
        minDeclareAmount: null,
        maxDeclareAmount: null,
      },
      tradeCode: [], // 国际收支交易编码表
      // 列表loading
      listLoading: false,
      declareSourceList: [
        { value: null, label: '全部' },
        { value: '0', label: '消费订单' },
        { value: '1', label: '自动申报' },
      ],
      // 状态数组
      declareType: [
        { value: null, label: '' },
        { value: '00', label: '进口申报' },
        { value: '01', label: '出口申报' },
      ],
      statusOption: [
        { value: null, label: '全部' },
        { value: '00', label: '待申报' },
        { value: '01', label: '申报中' },
        { value: '02', label: '申报成功' },
        { value: '03', label: '申报失败' },
        { value: '04', label: '取消申报' },
      ],
      restoreStatus: [
        { value: null, label: '' },
        { value: '00', label: '待申报' },
        { value: '01', label: '申报中' },
        { value: '02', label: '申报成功' },
        { value: '03', label: '申报失败' },
        { value: '04', label: '取消申报' },
      ],
      declareStatus: [
        { value: null, label: '' },
        { value: '00', label: '待申报' },
        { value: '01', label: '申报中' },
        { value: '02', label: '申报成功' },
        { value: '03', label: '申报失败' },
        { value: '04', label: '取消申报' },
      ],
      auditStatus: [
        { value: '00', label: '待提交' },
        { value: '01', label: '待初审' },
        { value: '02', label: '待复审' },
        { value: '03', label: '初审驳回' },
        { value: '04', label: '复审通过' },
        { value: '05', label: '复审驳回' },
        { value: '06', label: '待退款' },
        { value: '07', label: '风控失败' },
      ],
      paymentStatus: [
        { value: '0', label: '交易未执行' },
        { value: '1', label: '交易成功' },
        { value: '2', label: '交易处理中' },
        { value: '3', label: '交易失败' },
        { value: '4', label: '交易结果未知(特指调用渠道服务未知)' },
        { value: '9', label: '交易结果未知' },
        { value: '10', label: '代付款' },
        { value: '11', label: '已提交' },
      ],
      reviewStatus: [
        { value: '00', label: '待审核' },
        { value: '01', label: '审核成功' },
        { value: '02', label: '审核失败' },
        { value: '03', label: '校验中' },
        { value: '04', label: '校验失败' },
      ],
      currency: [
        { value: null, label: '' },
        { value: '01', label: '人民币' },
      ],
      confirmStatus: [
        { value: null, label: '' },
        { value: '00', label: '未确认' },
        { value: '01', label: '已确认' },
      ],
      exchangeMark: [
        { value: null, label: '' },
        { value: '0', label: '不换汇' },
        { value: '1', label: '换汇' },
      ],
      submitStatus: [
        { value: null, label: '' },
        { value: '00', label: '未提交' },
        { value: '01', label: '已提交' },
      ],
      total: 0, // 分页总条数
      page: 1, // 分页页码
      tableData: [], // 页面列表
      size: 10,
      searchTotal: 0,
      searchTotalAmount: 0,
      searchTotalFee: 0,
      // 文件上传
      declareNo: null,
      tradeNo: '',
      uploadType: null,
      merNo: null,
      serialNo: null,
      importInnerDialog: false,
      swapDialog: false,
      detailFormVisible: false,
      detailForm: [],
      detailsTotal: 0, // 分页总条数
      detailsPage: 1, // 分页页码
      detailsSize: 10, // 分条数

      // 订单重传相关数据
      orderVisible: true,

      // 失败文件下载加载动画
      singleIndex: null,

      // 导出变量
      downloadLoading: false,
      downloadVisible: false,
      downloadId: null,
      downloadFilename: null,
    }
  },
  created() {
    this.name = this.$route.meta.title
    this.queryDeclareOrder(1, 10)
  },
  methods: {
    check_amount(event, propertyName) {
      // 金额只能为正数，不能为负数
      // 这里直接将输入的字符串转换成数字的字符串
      this.searchForm[propertyName] = parseFloat(event.target.value.replace(/[^\d.]/g, '')) || ''
    },

    // 文件名称有些特殊符号不能使用，替换成''
    check_filename(event) {
      this.downloadFilename = event.target.value.replace(/[\\\\/:*?\"<>|]/g, '')
    },

    // 路由编辑弹窗
    openEdit: function (index, row) {
      this.$refs.edit.openEdit(index, row)
    },
    declare: function () {
      this.queryDeclareOrder(1, 10)
    },
    openAttached: function (index, row) {
      this.$refs.attached.openAttached(index, row)
    },
    openAttached2(row) {
      this.$refs.attached2.open(row)
    },
    openAttached3(row) {
      this.$refs.attached3.open(row)
    },
    openAttached4(row) {
      this.$refs.attached4.open(row)
    },

    queryData() {
      this.page = 1
      this.queryDeclareOrder()
    },

    // 查询
    queryDeclareOrder() {
      this.tableData = []
      let minDeclareAmount = parseFloat(this.searchForm.minDeclareAmount) || 0
      let maxDeclareAmount = parseFloat(this.searchForm.maxDeclareAmount) || 0
      if (maxDeclareAmount < minDeclareAmount) {
        this.$message.error('查询申报最小金额不能大于最大金额')
        return
      }
      const param = Common.setNull({
        page: this.page ? this.page : 1,
        size: this.size ? this.size : 10,
        startDeclareTime: this.searchForm.declareTime ? this.searchForm.declareTime[0] : null,
        endDeclareTime: this.searchForm.declareTime ? this.searchForm.declareTime[1] : null,
        ...this.searchForm,
        logInMerNo: this.$store.getters.merNo,
        logInMerName: this.$store.getters.merName,
      })
      this.listLoading = true
      queryMerDeclareOrder(param)
        .then((res) => {
          this.listLoading = false
          this.total = res.data.total
          if (res.data.list) this.tableData = res.data.list
        })
        .catch((error) => {
          this.listLoading = false
          console.log(error) // 请求失败返回的数据
        })
    },
    handleDetail(declareNo) {
      this.detailFormVisible = true
      this.declareNo = declareNo
      this.detailForm = []
      const param = Common.setNull({
        page: this.detailsPage ? this.detailsPage : 1,
        size: this.detailsSize ? this.detailsSize : 10,
        declareNo: declareNo,
      })
      queryDeclareOrderDetails(param)
        .then((res) => {
          if (res.data.list) this.detailForm = res.data.list
          this.detailsPage = res.data.page
          this.detailsTotal = res.data.total
        })
        .catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
    },
    handleDetailByPage() {
      this.handleDetail(this.declareNo)
    },
    getTxCode() {
      const param = {
        itemCode: 'international-income-code',
        priority: '1',
        page: 1,
        size: 1000,
      }
      CommonApi.getDict(param).then((res) => {
        // console.log('国际收支收入交易编码表', res)
        this.tradeCode = res.data.list
      })
      const params = {
        itemCode: 'international-expense-code',
        priority: '1',
        page: 1,
        size: 1000,
      }
      CommonApi.getDict(params).then((res) => {
        // console.log('国际收支支出交易编码表', res)
        this.tradeCode.push(res.data.list)
      })
    },

    showDownloadDialog(declareNo) {
      this.downloadFilename = null
      this.downloadVisible = true
      this.downloadId = declareNo
    },

    closeDownloadDialog() {
      this.downloadFilename = null
      this.downloadVisible = false
      this.downloadId = null
    },

    // 失败文件下载
    downloadFail() {
      if(!this.downloadFilename){
        this.$message.error('请填写下载文件名称')
        return
      }
      this.downloadLoading = true
      declarationFileDownloadAsync({
        declareNo: this.downloadId,
        recordUser: this.$store.getters.merNo,
        fileName: this.downloadFilename,
        recordType: '2',
        moduleName: '02',
      })
        .then((res) => {
          this.downloadLoading = false
          this.downloadFilename = null
          this.downloadVisible = false
          this.downloadId = null
          this.$message.success('处理中，请稍候前往文件下载页面查看')
        })
        .catch((error) => {
          this.downloadLoading = false
          console.log(error) // 请求失败返回的数据
        })
    },

    // 下载申报附件
    downloadDeclareFile(row) {
      this.$refs.declareOriginFileList.open(row)   
    },
    // 提交申请
    submitTradeOrder(exchangeMark) {
      const param = Object.assign(
        {},
        {
          declareNo: this.declareNo,
          merNo: this.merNo,
          submitStatus: '01',
          tradeNo: this.tradeNo,
          exchangeMark: exchangeMark,
        }
      )
      updateDeclarationInfo(param)
        .then((res) => {
          // console.log(res)
          this.$message({
            message: '提交成功',
            type: 'success',
          })
          this.swapDialog = false
          this.queryDeclareOrder()
        })
        .catch((error) => {
          console.log(error) // 请求失败返回的数据
          this.listLoading = false
        })
    },
    // 时间格式化
    formatDate(row, column) {
      // 获取单元格数据
      const data = row[column.property]
      if (data === undefined) {
        return null
      }
      return moment(data).format('YYYY-MM-DD HH:mm:ss')
    },

    // 还原申报下载逻辑
    openDeclareDialog(row) {
      this.$refs.declareFileList.open(row)
    },

    // 订单重传详情逻辑
    openOrderDialog(row) {
      this.$refs.orderReload.open(row)
    },

    orderReloadSuccess() {
      this.queryDeclareOrder()
    },

    // 重置
    clearUp() {
      this.searchForm = {
        merNo: null,
        merName: null,
        declareTime: null,
        declareStatus: null,
        restoreStatus: null,
        tradeStatus: null,
        restoreNo: null,
        tradeNo: null,
        auditStatus: null,
        orderStatus: null,
        paymentStatus: null,
        minDeclareAmount: null,
        maxDeclareAmount: null,
      }
    },
  },

  computed: {
    ...mapGetters(['platformMerchantType']),

    logInMerNo() {
      return this.$store.state.user.merNo
      //return 'M400065240ZqYhtfk1';
    },
  },

  watch: {
    platformMerchantType(oldValue, newValue) {
      console.log('检查到platformMerchantType发生变化', oldValue, newValue)

      this.searchForm.merNo = null
      this.searchForm.merName = null
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
::v-deep .inputStyle .el-form-item__content {
  width: 270px;
}
::v-deep .operateStyle .el-form-item__content {
  width: 500px;
}
</style>
